module.exports = __webpack_public_path__ + "static/media/bluesky.500b0bad.svg";